import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import DialogHeader from 'components/DialogHeader';
import { useHistory } from 'react-router-dom';
import { useStore } from 'store';
import { AuthContext } from 'fbase/authContext';
import { usePageTitle } from 'hooks/usePageTitle';

const UserAgreement = () => {

  usePageTitle('User Agreement');

  const history = useHistory();
  const { currentUser } = useContext(AuthContext);

  const isAnonymousUser = currentUser && currentUser.isAnonymous ? currentUser.isAnonymous : null;
  const {
    state: {
      ui: { isAgreementPopOpen }
    },
    dispatch
  } = useStore();

  const onBack = () => {
    if (isAgreementPopOpen) {
      dispatch({
        type: 'UI_ACTION_AGREEMENT_POPUP',
        payload: false
      });

      if (!isAnonymousUser) {
        dispatch({
          type: 'UI_ACTION_UPDATED_TERMS_POPUP',
          payload: true
        });
      }
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <DialogHeader text="User Agreement" onBack={onBack} closeIconId="closeUserAgreement" />
      <Box padding={2}>
        <Typography variant="h6">Lokobee Consumer END USER LICENSE AGREEMENT</Typography>
        <Typography variant="body2" align="justify">
          This copy of Lokobee Consumer App ("the Software Product") and accompanying documentation is licensed and not sold. This Software Product is protected by copyright laws and treaties, as well
          as laws and treaties related to other forms of intellectual property. 1Ambrosia. or its subsidiaries, affiliates, and suppliers (collectively "1Ambrosia.") own intellectual
          property rights in the Software Product. The Licensee's ("you" or "your") license to download, use, copy, or change the Software Product is subject to these rights and to all the terms and
          conditions of this End User License Agreement ("Agreement").
        </Typography>
        <Typography variant="h6">Acceptance</Typography>
        <Typography variant="body2" align="justify">
          YOU ACCEPT AND AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT BY SELECTING THE "ACCEPT" OPTION AND DOWNLOADING THE SOFTWARE PRODUCT OR BY INSTALLING, USING, OR COPYING THE SOFTWARE
          PRODUCT. YOU MUST AGREE TO ALL OF THE TERMS OF THIS AGREEMENT BEFORE YOU WILL BE ALLOWED TO DOWNLOAD THE SOFTWARE PRODUCT. IF YOU DO NOT AGREE TO ALL OF THE TERMS OF THIS AGREEMENT, YOU MUST
          SELECT "DECLINE" AND YOU MUST NOT INSTALL, USE, OR COPY THE SOFTWARE PRODUCT.
        </Typography>
        <Typography variant="h6">License Grant</Typography>
        <Typography variant="body2" align="justify">
          This Agreement entitles you to install and use one copy of the Software Product. In addition, you may make one archival copy of the Software Product. The archival copy must be on a storage
          medium other than a hard drive, and may only be used for the reinstallation of the Software Product. This Agreement does not permit the installation or use of multiple copies of the Software
          Product, or the installation of the Software Product on more than one computer at any given time, on a system that allows shared used of applications, on a multi-user network, or on any
          configuration or system of computers that allows multiple users. Multiple copy use or installation is only allowed if you obtain an appropriate licensing agreement for each user and each
          copy of the Software Product.
        </Typography>
        <Typography variant="h6">Restrictions on Transfer</Typography>
        <Typography variant="body2" align="justify">
          Without first obtaining the express written consent of 1Ambrosia., you may not assign your rights and obligations under this Agreement, or redistribute, encumber, sell, rent, lease,
          sublicense, or otherwise transfer your rights to the Software Product.
        </Typography>
        <Typography variant="h6">Restrictions on Use</Typography>
        <Typography variant="body2" align="justify">
          You may not use, copy, or install the Software Product on any system with more than one computer, or permit the use, copying, or installation of the Software Product by more than one user or
          on more than one computer. If you hold multiple, validly licensed copies, you may not use, copy, or install the Software Product on any system with more than the number of computers
          permitted by license, or permit the use, copying, or installation by more users, or on more computers than the number permitted by license.
        </Typography>
        <Typography variant="body2" align="justify">
          You may not decompile, "reverse-engineer", disassemble, or otherwise attempt to derive the source code for the Software Product.
        </Typography>
        <Typography variant="body2" align="justify">
          You may not use the database portion of the Software Product in connection with any software other than the Software Product.
        </Typography>
        <Typography variant="h6">Restrictions on Alteration</Typography>
        <Typography variant="body2" align="justify">
          You may not modify the Software Product or create any derivative work of the Software Product or its accompanying documentation. Derivative works include but are not limited to translations.
          You may not alter any files or libraries in any portion of the Software Product. You may not reproduce the database portion or create any tables or reports relating to the database portion.
        </Typography>
        <Typography variant="h6">Restrictions on Copying</Typography>
        <Typography variant="body2" align="justify">
          You may not copy any part of the Software Product except to the extent that licensed use inherently demands the creation of a temporary copy stored in computer memory and not permanently
          affixed on storage medium. You may make one archival copy which must be stored on a medium other than a computer hard drive.
        </Typography>
        <Typography variant="h6">Disclaimer of Warranties and Limitation of Liability</Typography>
        <Typography variant="body2" align="justify">
          UNLESS OTHERWISE EXPLICITLY AGREED TO IN WRITING BY 1AMBROSIA, 1AMBROSIA MAKES NO OTHER WARRANTIES, EXPRESS OR IMPLIED, IN FACT OR IN LAW, INCLUDING, BUT NOT LIMITED TO, ANY
          IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OTHER THAN AS SET FORTH IN THIS AGREEMENT OR IN THE LIMITED W ARRANTY DOCUMENTS PROVIDED WITH THE SOFTWARE PRODUCT.
        </Typography>
        <Typography variant="body2" align="justify">
          1Ambrosia. makes no warranty that the Software Product will meet your requirements or operate under your specific conditions of use. 1Ambrosia. makes no warranty that operation of
          the Software Product will be secure, error free, or free from interruption. YOU MUST DETERMINE WHETHER THE SOFTWARE PRODUCT SUFFICIENTLY MEETS YOUR REQUIREMENTS FOR SECURITY AND
          UNINTERRUPTABILITY. YOU BEAR SOLE RESPONSIBILITY AND ALL LIABILITY FOR ANY LOSS INCURRED DUE TO FAILURE OF THE SOFTWARE PRODUCT TO MEET YOUR REQUIREMENTS. 1AMBROSIA WILL NOT, UNDER ANY
          CIRCUMSTANCES, BE RESPONSIBLE OR LIABLE FOR THE LOSS OF DATA ON ANY COMPUTER OR INFORMATION STORAGE DEVICE.
        </Typography>
        <Typography variant="body2" align="justify">
          UNDER NO CIRCUMSTANCES SHALL 1AMBROSIA, ITS DIRECTORS, OFFICERS, EMPLOYEES OR AGENTS BE LIABLE TO YOU OR ANY OTHER PARTY FOR INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL, PUNITIVE, OR
          EXEMPLARY DAMAGES OF ANY KIND (INCLUDING LOST REVENUES OR PROFITS OR LOSS OF BUSINESS) RESULTING FROM THIS AGREEMENT, OR FROM THE FURNISHING, PERFORMANCE, INSTALLATION, OR USE OF THE
          SOFTWARE PRODUCT, WHETHER DUE TO A BREACH OF CONTRACT, BREACH OF WARRANTY, OR THE NEGLIGENCE OF 1AMBROSIA OR ANY OTHER PARTY, EVEN IF 1AMBROSIA IS ADVISED BEFOREHAND OF THE
          POSSIBILITY OF SUCH DAMAGES. TO THE EXTENT THAT THE APPLICABLE JURISDICTION LIMITS 1AMBROSIA'S ABILITY TO DISCLAIM ANY IMPLIED WARRANTIES, THIS DISCLAIMER SHALL BE EFFECTIVE TO THE
          MAXIMUM EXTENT PERMITTED.
        </Typography>
        <Typography variant="h6">Limitation of Remedies and Damages</Typography>
        <Typography variant="body2" align="justify">
          Your remedy for a breach of this Agreement or of any warranty included in this Agreement is the correction or replacement of the Software Product. Selection of whether to correct or replace
          shall be solely at the discretion of 1Ambrosia.. 1Ambrosia. reserves the right to substitute a functionally equivalent copy of the Software Product as a replacement. If 1Ambrosia
          is unable to provide a replacement or substitute Software Product or corrections to the Software Product, your sole alternate remedy shall be a refund of the purchase price for the
          Software Product exclusive of any costs for shipping and handling.
        </Typography>
        <Typography variant="body2" align="justify">
          Any claim must be made within the applicable warranty period. All warranties cover only defects arising under normal use and do not include malfunctions or failure resulting from misuse,
          abuse, neglect, alteration, problems with electrical power, acts of nature, unusual temperatures or humidity, improper installation, or damage determined by 1Ambrosia. to have been
          caused by you. All limited warranties on the Software Product are granted only to you and are non-transferable. You agree to indemnify and hold 1Ambrosia. harmless from all claims,
          judgments, liabilities, expenses, or costs arising from your breach of this Agreement and/or acts or omissions.
        </Typography>
        <Typography variant="h6">Governing Law, Jurisdiction and Costs</Typography>
        <Typography variant="body2" align="justify">
          This Agreement is governed by the laws of Delaware, without regard to Delaware's conflict or choice of law provisions.
        </Typography>
        <Typography variant="h6">Severability</Typography>
        <Typography variant="body2" align="justify">
          If any provision of this Agreement shall be held to be invalid or unenforceable, the remainder of this Agreement shall remain in full force and effect. To the extent any express or implied
          restrictions are not permitted by applicable laws, these express or implied restrictions shall remain in force and effect to the maximum extent permitted by such applicable laws.
        </Typography>
        <Typography variant="h6">Profanity policy</Typography>
        <Typography variant="body2" align="justify">
          We want all our members to have a positive experience when using Lokobee apps and website. We don’t allow members to use language that we consider to be defamatory, offensive, or that could
          be seen as abuse or harassment. 1Ambrosia, doesn't allow the use of hateful, racist, offensive, profane, or vulgar language in any areas of the website. Areas include listings, products,
          profiles, feedback, discussion boards, and more. Defamatory language (language or comments that could be considered harmful to the reputation of another 1Ambrosia member) is also strictly
          prohibited. How you let us know about the inappropriate language depends on where you see it:
        </Typography>
        <ul>
          <li>If someone left you abusive or profane feedback contact us to report the feedback at tech@1ambrosia.com</li>
          <li>If you've come across a listing that you believe is offensive, please report it to us at tech@1ambrosia.com</li>
          <li>
            If another member has made comments about you that you consider defamatory, or if you've received offensive or abusive messages from another member, you can report it to us at
            tech@1ambrosia.com
          </li>
        </ul>
        <Typography variant="body2" align="justify">
          If you've received messages which you consider threatening and are worried about your safety, we recommend contacting your local law enforcement agency.
        </Typography>
        <Typography variant="h6">Look & feel, content of Lokobee app and website</Typography>
        <Typography variant="body2" align="justify">
          1Ambrosia shall have the right to make changes to the design, layout and other aspects of “look & feel and contents” of Lokobee app’s and website provided that such changes are consistent
          with the basic use model.
        </Typography>
      </Box>
    </>
  );
};

export default UserAgreement;
